import { Component, OnInit } from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';
import {ApiService} from '../../../shared/services/api.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-statistics-datamanagement',
  templateUrl: './statistics-datamanagement.component.html',
  styles: []
})

export class StatisticsDatamanagementComponent implements OnInit {

  loadingIndicator = true;
  loadingIndicatorDataManagement = true;

  marketStatisticsAvailableYears = [0];
  marketStatisticsSelectedYears = 0;
  marketStatisticsDataManagementArray = [];
  marketStatisticsDataManagementArrayFiltered = [];
  marketStatisticsPerPage = 100;

  total =  {
    marketdates: 0,
    accountingsAll: 0,
    accountingsWithoutAbsent: 0,
    sqmAll: 0,
    sqmWithoutAbsent: 0,
    sumPriceTotal: 0,
    marketmanagers: 0
  };

  constructor(private jhiLanguageService: JhiLanguageService, private apiService: ApiService) {
    this.jhiLanguageService.setLocations(['evaluation']);
  }

  ngOnInit() {
    this.loadingIndicatorDataManagement = true;
    this.getMarketStatisticsDataManagement();
  }

  getMarketStatisticsDataManagement() {
    this.apiService.get('backoffice/market-statistics-data-management')
      .subscribe(response => {
        const marketStatisticsRaw = response.json() as {
          branchId: number,
          branchString: string,
          id: string,
          indexName: string
          year: number,
          month: number,
          value: number,
          monthlyValue: number,
          marketdateCount: number,
          monthlyMarketdateCount: number,
          sumRow: boolean
        }[];

        let lastYear = 0;
        let lastMonth = 0;
        let lastMonthlyValue = 0;
        let lastMarketdateCount = 0;
        let lastMonthlyMarketdateCount = 0;

        const marketStatisticsWithMonthly = [];

        marketStatisticsRaw.forEach((statistic) => {
            let lastYearMonth = lastYear + '-' + lastMonth;
            if (lastYearMonth === '0-0') {
              lastYear = statistic.year;
              lastMonth = statistic.month;
              lastYearMonth = lastYear + '-' + lastMonth;
            }

            if (lastYearMonth !== statistic.year + '-' + statistic.month) {
              marketStatisticsWithMonthly.push({
                branchId: 0, branchString: '---', id: '', indexName: '', year: lastYear, month: lastMonth,
                value: 0, monthlyValue: lastMonthlyValue, marketdateCount: lastMarketdateCount, monthlyMarketdateCount: lastMonthlyMarketdateCount, sumRow: true
              });
            }
            lastYear = statistic.year;
            lastMonth = statistic.month;
            lastMonthlyValue = statistic.monthlyValue;
            lastMonthlyMarketdateCount = statistic.monthlyMarketdateCount;
            lastMarketdateCount = statistic.marketdateCount;
            marketStatisticsWithMonthly.push(statistic);

            if (!this.marketStatisticsAvailableYears.includes(statistic.year)) {
              this.marketStatisticsAvailableYears.push(statistic.year);
            }
          });

        marketStatisticsWithMonthly.push({
          branchId: 0, branchString: '---', id: '', indexName: '', year: lastYear, month: lastMonth, value: -1,
          monthlyValue: lastMonthlyValue, marketdateCount: lastMarketdateCount,
          monthlyMarketdateCount: lastMonthlyMarketdateCount, sumRow: true
        });

        this.marketStatisticsDataManagementArrayFiltered = marketStatisticsWithMonthly;
        this.marketStatisticsDataManagementArray = marketStatisticsWithMonthly;

        this.loadingIndicatorDataManagement = false;

      });
  }

  saveMarketStatisticsToCsv() {
    const headers = [
      'Jahr',
      'Monat',
      'Niederlassung',
      'Abgerechnete VE',
      'Monatswert',
      'Marktabrechnungen',
      'Marktabrechnungen Monatswert',
      ];
    let body = headers.join(';') + '\r\n';

    this.marketStatisticsDataManagementArrayFiltered.forEach(
      (entry) => {
        body = body.concat(entry.year, ';');
        body = body.concat(entry.month, ';');
        body = body.concat(entry.branchString, ';');
        body = body.concat(entry.value, ';');
        body = body.concat(entry.monthlyValue, ';');
        body = body.concat(entry.marketdateCount, ';');
        body = body.concat(entry.monthlyMarketdateCount, ';\r\n');
      }
    );
    const blob = new Blob([body], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, 'Marktabrechnungsstatistik-Datenmanagement.csv');
  }

  filterByYear(year: number) {
    this.marketStatisticsDataManagementArrayFiltered = this.marketStatisticsDataManagementArray.filter(
      (entry) => (year === 0) ? true : entry.year === year);
    this.marketStatisticsSelectedYears = year;
  }

}



// WEBPACK FOOTER //
// ./src/app/evaluation/components/statistics-datamanagement/statistics-datamanagement.component.ts